import React, { useEffect, useState, useRef, useMemo } from "react"
import { withRouter, Link } from "react-router-dom"
import { Card, CardBody, Col, Row, Badge, Button } from "reactstrap"
import Select from "react-select"
import paginationFactory, {
  PaginationListStandalone,
  PaginationProvider,
} from "react-bootstrap-table2-paginator"
import moment from "moment-timezone"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import { billStatus, messageTitle } from "constants/common"
import { convertUtcToLocal } from "../../helpers/util"
import { getSettingData } from "../../store/settings/actions"
import { getCarParks as onGetCarParks } from "../../store/carpark/actions"
import {
  getBills as onGetBills,
  updateBill as onUpdateBill,
  clearMessage,
  resetExportFileData,
  getExportBills,
} from "../../store/bill/actions"

import { isEmpty, reduce, map } from "lodash"
import InvoiceView from "./InvoiceView"
import DeleteModal from "components/Common/DeleteModal" // more like a confirmation modal
import toastr from "toastr"
import "toastr/build/toastr.min.css"

//redux
import { useSelector, useDispatch } from "react-redux"

const getColor = status => {
  if (status == billStatus[1]) { // Pending
    return "warning"
  } else if (status == billStatus[3]) { // Cancelled
    return "danger"
  } else {
    return "success"
  }
}

const sizePerPage = 25;
const BillList = props => {
  const dispatch = useDispatch()
  const [bill, setBill] = useState()
  const [startDate, setStartDate] = useState()
  const [endDate, setEndDate] = useState()
  const [fileType, setFileType] = useState({ label: "PDF", value: "pdf" })

  const { bills, message, pagination, error, settingData, carParks, file } =
    useSelector(state => ({
      bills: state.bills.billList,
      pagination: state.bills.pagination,
      message: state.bills.message,
      error: state.bills.error,
      settingData: state.Settings.settingData,
      carParks: state.carPark.carParkList,
      file: state.bills.file,
    }))
  const [filterStatus, setFilterStatus] = useState({
    value: "All",
    label: "All",
  })

  const [filterCarpark, setFilterCarpark] = useState({
    value: "All",
    label: "All Primary Locations",
  })

  const [filters, setFilters] = useState({})

  const [modal, setModal] = useState(false)
  const [comment, setComment] = useState("")
  const [isEdit, setIsEdit] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)
  const [primaryStations, setPrimaryStations] = useState([]);

  const [searchKey, setSearchKey] = useState("");
  const [filteredRes, setFilteredRes] = useState([]);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [customValidation, setCustValidation] = useState({
    validComment: true,
  })

  useEffect(() => {
    if (bills) {
      setFilteredRes(bills);
    }
  }, [bills]);

  useEffect(() => {
    if (searchKey.length >= 2 || searchKey == "") {
      setCurrentPage(1);
      dispatch(onGetBills({ ...filters, page: currentPage, size: sizePerPage, search: searchKey }));
      setFilters({ ...filters, search: searchKey });
    }    
  }, [searchKey]);

  const { SearchBar } = Search

  const pageOptions = {
    page: currentPage,
    sizePerPage: sizePerPage,
    totalSize: pagination?.totalItems || 0, // replace later with size(users),
    custom: true,
    totalPages: pagination?.totalPages || 0,
    onPageChange: setCurrentPage,
  }

  const handleViewBillClick = e => {
    setBill(e)
    toggle()
  }

  const handleUpdatePaidClick = bill => {
    if (bill?.status == "Pending") {
      setBill({ ...bill, action: "paid" })
      setShowDeleteModal(true)
    }
  }

  const handleUpdateCancelledClick = bill => {
    if (bill?.status == "Pending") {
      setBill({ ...bill, action: "cancel" })
      setShowDeleteModal(true)
    }
  }

  const handleConfirmClick = (e) => {
    // setLoading(true)
    
    if (isEmpty(comment)) {
      setCustValidation({validComment:false})
      e.preventDefault()
      return false;
    }

    if (bill?.action == "paid") {
      let updateBill = { id: bill?._id, status: "Paid", comment }
      dispatch(onUpdateBill(updateBill))
    } else if (bill?.action == "cancel") {
      let updateBill = { id: bill?._id, status: "Cancelled", comment }
      dispatch(onUpdateBill(updateBill))
    }
    setShowDeleteModal(false)
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "desc",
    },
  ]

  const billListColumns = [
    {
      text: "id",
      dataField: "_id",
      sort: true,
      hidden: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, bill) => <>{bill._id}</>,
    },
    {
      text: "Bill ID",
      dataField: "billId",
      sort: true,
    },
    {
      text: "Name",
      dataField: "useName",
      sort: true,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => (
        <>
          <p className="text-muted mb-0">{record?.userId?.userId || ""}</p>
          <h5 className="font-size-14 mb-1">
            <Link to="#" className="text-dark">
              {record?.userId?.name || ""}
            </Link>
          </h5>
        </>
      ),
    },
    // {
    //   text: "Carpark",
    //   dataField: "carParkTitle",
    //   sort: true,
    //   formatter: (cellContent, record) => (
    //     <>{record?.userId?.primaryStation || ""}</>
    //   ),
    // },
    {
      text: "Role",
      dataField: "Role",
      sort: true,
      formatter: (cellContent, record) => (
        <>{record?.userId?.role?.roleTitle || ""}</>
      ),
    },
    {
      text: "Pyment Details",
      dataField: "seasonType",
      sort: true,
      formatter: (cellContent, record) => (
        <>{record?.billDesc?.map((desc, index) => {
          return <p key={index}>{desc.seasonTitle}</p>
        })}</>
        //<>{record?.billDesc[0]?.seasonTitle || ""}</>
      ),
    },
    {
      dataField: "status",
      text: "Bill Status",
      sort: true,
      formatter: (cellContent, record) => (
        <Badge className={"bg-" + getColor(record?.status)}>
          {record?.status}
        </Badge>
      ),
    },
    {
      dataField: "billDate",
      text: "Billing Date",
      sort: true,
      formatter: (cellContent, record) => {
        return <>{record ? convertUtcToLocal(record?.billDate) : ""}</>
      },
    },
    {
      dataField: "Amount",
      text: "Amount",
      sort: true,
      formatter: (cellContent, record) => {
        return (
          <>
            {record ? "SGD " + parseFloat(record?.billAmount.toString()).toFixed(2) : ""}
          </>
        )
      },
    },
    {
      dataField: "menu",
      isDummyField: true,
      editable: false,
      text: "Action",
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, record) => (
        <div className="d-flex gap-3">
          <Link
            className="text-warning"
            to="#"
            style={{
              opacity: record?.status === billStatus[1] ? 5 : "0.4",
              pointerEvents: record?.status === billStatus[1] ? "auto" : "none",
            }}
          >
            <i
              className="mdi mdi-currency-usd font-size-24"
              id="edittooltip"
              onClick={e => handleUpdatePaidClick(record)}
              data-toggle="tooltip"
              data-placement="top"
              title="Update Paid"
            ></i>
          </Link>
          <Link
            className="text-danger"
            to="#"
            style={{
              opacity: record?.status === billStatus[1] ? 5 : "0.4",
              pointerEvents: record?.status === billStatus[1] ? "auto" : "none",
            }}
          >
            <i
              className="mdi mdi-cancel font-size-24"
              id="tooltip"
              onClick={() => handleUpdateCancelledClick(record)}
              data-toggle="tooltip"
              data-placement="top"
              title="Cancel bill"
            ></i>
          </Link>
          <Link className="text-info" to="#">
            <i
              className="mdi mdi-file-eye font-size-24"
              id="tooltip"
              onClick={() => handleViewBillClick(record)}
              data-toggle="tooltip"
              data-placement="top"
              title="View Bill"
            ></i>
          </Link>
        </div>
      ),
    },
  ]

  useMemo(() => {
    dispatch(onGetCarParks({ status: "Available" }));
    dispatch(onGetBills({ ...filters, page: currentPage, size: sizePerPage }));
    dispatch(getSettingData());
  }, []);

  useEffect(() => {
    dispatch(onGetBills({ ...filters, page: currentPage, size: sizePerPage }));
  }, [currentPage]);

  useEffect(() => {
    if (settingData["cpfProperties"]) {
      const { cpfBuilding } = settingData["cpfProperties"]
      const list = !isEmpty(cpfBuilding) ? cpfBuilding.split(`,`) : []
      setPrimaryStations(list)
    }
  }, [settingData]);

  useEffect(() => {
    if (!isEmpty(filteredRes) && !!isEdit) {
      setIsEdit(false)
    }
  }, [filteredRes]);

  useEffect(() => {
    if (file) {
      handleExport(file)
      setTimeout(() => {
        dispatch(resetExportFileData())
      }, 300)
    }
  }, [file]);

  useMemo(() => {
    if (message) {
      message == "PDF file content not found." ||
        message == "Failed to export invalid file type."
        ? toastr.error(message, messageTitle)
        : toastr.success(message, messageTitle)
      dispatch(onGetBills({ ...filters,page: currentPage, size: sizePerPage }))
      setTimeout(() => {
        dispatch(clearMessage())
      }, 300)
    }
  }, [dispatch, message]);

  useMemo(() => {
    if (!isEmpty(error)) {
      toastr.error(error.message, messageTitle)
      setTimeout(() => {
        dispatch(clearMessage())
      }, 500)
    }
  }, [dispatch, error]);

  const toggle = () => {
    setModal(!modal)
  }

  var node = useRef()

  const resetForm = () => {
    setBill(null)
  }

  // Runs when status filter change
  const handleFilter = e => {
    setCurrentPage(1);
    setFilters({ ...filters, status: e.value });
    setFilterStatus(e);
  };

  // Runs when filterStatus is updated, which is from handleFilter function
  useEffect(() => {
    // if (filterStatus.value == "All") {
    //   dispatch(onGetBills({...filters, page: currentPage, size: sizePerPage}))
    // } else {
    //   dispatch(onGetBills({ ...filters, status: filterStatus.value, page: currentPage, size: sizePerPage }))
    //   setFilters({ ...filters, status: filterStatus.value })
    // };
    dispatch(onGetBills({ ...filters, page: currentPage, size: sizePerPage }));
  }, [filterStatus])

  const handleCarparkFilter = e => {
    setFilterCarpark(e);
    setCurrentPage(1);
    if (e.value == "All") {
      dispatch(onGetBills({ ...filters, carpark: null, page: currentPage, size: sizePerPage }))
    } else {
      dispatch(onGetBills({ ...filters, carpark: e.value, page: currentPage, size: sizePerPage }))
      setFilters({ ...filters, carpark: e.value })
    };
  }

  const handleTableChange = () => {

  }

  const handleStartDateSearch = value => {
    // let payload = { ...filters }
    // if (value && endDate) {
    //   payload = {
    //     ...payload,
    //     startDate: moment(value).format("YYYY-MM-DD"),
    //     endDate: moment(endDate).format("YYYY-MM-DD"),
    //   }
    // }
    setCurrentPage(1);
    dispatch(onGetBills({ ...filters, startDate: value, page: currentPage, size: sizePerPage }));
    setFilters({ ...filters, startDate: value });
    setStartDate(value);
  }

  const handleEndDateSearch = value => {
    // let payload = { ...filters }
    // if (startDate && value) {
    //   payload = {
    //     ...payload,
    //     startDate: moment(startDate).format("YYYY-MM-DD"),
    //     endDate: moment(value).format("YYYY-MM-DD"),
    //   }
    // }
    setCurrentPage(1);
    dispatch(onGetBills({ ...filters, endDate: value, page: currentPage, size: sizePerPage }))
    setFilters({ ...filters, endDate: value })
    setEndDate(value)
  }

  const handleReset = () => {
    setCurrentPage(1);
    dispatch(onGetBills({ page: currentPage, size: sizePerPage })) // Set current page to first page
    setFilters({})
    setEndDate()
    setStartDate()
    setFilterStatus({
      value: "All",
      label: "All",
    })
    setFilterCarpark({
      value: "All",
      label: "All Primary Locations",
    })
    setSearchKey("")
  }

  let statusTypeOptions = billStatus.map(el => {
    return {
      value: `${el}`,
      label: `${el}`,
    }
  })

  let stationOptions = map(primaryStations, el => {
    return {
      value: `${el.trim()}`,
      label: `${el.trim()}`,
    }
  })
  stationOptions.unshift({ value: "All", label: "All Primary Locations" })

  const setDownloadType = () => {
    dispatch(getExportBills({...filters,file_type: fileType.value,}))
  }

  const handleExport = fileData => {
    const fileName =
      `manage_bills_` +
      new Date().getTime() +
      `.${fileType.value.toLowerCase()}`
    const downloadType =
      fileType.value == "csv" || fileType.value == "xlsx"
        ? "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        : "application/pdf"
    const base64data = `data:${downloadType};base64,${fileData}`
    const downloadLink = document.createElement("a")
    downloadLink.href = base64data
    downloadLink.download = fileName
    downloadLink.click()
    return fileName
  }

  const handleSelectType = e => {
    setFileType(e)
  }

  const fileTypeOptions = [
    {
      label: "PDF",
      value: "pdf",
    },
    {
      label: "CSV",
      value: "csv",
    },
    {
      label: "XLSX",
      value: "xlsx",
    },
  ]

  const keyField = "_id"
  let totalBill = 0
  map(filteredRes || [], el => {
    totalBill = totalBill + parseFloat(el.billAmount.toString())
  })

  const emptyDataMessage = () => {
    return <p style={{ textAlign: "center" }}>No data to display</p>
  }

  return (
    <React.Fragment>
      <DeleteModal
        show={showDeleteModal}
        text={
          bill?.action == "paid" ? "Yes, update as paid" : "Yes, cancel bill"
        }
        title={bill?.action == "paid" ? `Are you sure to update ${bill?.userId?.name}'s bill as paid?` : `Are you sure to cancel ${bill?.userId?.name}'s bill?`}
        icon={
          bill?.action == "paid"
            ? "mdi mdi-currency-usd"
            : "mdi mdi-cancel"
        }
        iconColor={bill?.action == "paid" ? "text-warning" : "text-danger"}
        // childComponent={}
        childComponent={
          <div>
            <input
              name="comment"
              className="form-control"
              id="comment"
              rows="2"
              onChange={e => {
                setComment(e.target.value)
                setCustValidation({validComment:comment!=""})
              }}
              onBlur={e => { setComment(e.target.value), setCustValidation({validComment:comment!=""}) }}
              value={comment || ""}
            />
            {!customValidation.validComment && (
              <div className="invalid-feedback" style={{display: "block",}}>
                Please input comment
              </div>
            )}
          </div>
        }
        onDeleteClick={handleConfirmClick}
        onCloseClick={() => setShowDeleteModal(false)}
      />
      <Row>
        <Col lg="12">
          <Card>
            <CardBody>
              <PaginationProvider
                pagination={paginationFactory(pageOptions)}
                keyField={keyField}
                columns={billListColumns}
                data={filteredRes || []}
              >
                {({ paginationProps, paginationTableProps }) => {
                  return (
                    <ToolkitProvider
                      keyField={keyField}
                      data={filteredRes || []}
                      columns={billListColumns}
                      exportCSV={{
                        fileName: `BillList.csv`,
                        separator: "|",
                        noAutoBOM: false,
                        onlyExportFiltered: true,
                        exportAll: false,
                      }}
                      bootstrap4
                      search
                    >
                      {toolkitProps => (
                        <React.Fragment>
                          <Row className="mb-2">
                            <Col sm="2">
                              <Select
                                placeholer={"Select status"}
                                name={"statusType"}
                                value={filterStatus}
                                onChange={e => {
                                  handleFilter(e)
                                }}
                                options={statusTypeOptions}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col sm="2">
                              <Select
                                placeholer={"Select carpark"}
                                name={"filterCarpark"}
                                value={filterCarpark}
                                onChange={e => {
                                  handleCarparkFilter(e)
                                }}
                                options={stationOptions}
                                classNamePrefix="select2-selection"
                              />
                            </Col>
                            <Col sm="2">
                              <input
                                className="form-control"
                                type="date"
                                defaultValue={startDate}
                                value={startDate ? startDate : " "}
                                id="startDate"
                                name="startDate"
                                onChange={e =>
                                  handleStartDateSearch(e.target.value)
                                }
                                onBlur={e =>
                                  handleStartDateSearch(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm="2">
                              <input
                                className="form-control"
                                type="date"
                                defaultValue={endDate}
                                value={endDate ? endDate : " "}
                                id="endDate"
                                name="endDate"
                                onChange={e =>
                                  handleEndDateSearch(e.target.value)
                                }
                                onBlur={e =>
                                  handleEndDateSearch(e.target.value)
                                }
                              />
                            </Col>
                            <Col sm="1">
                              <Button
                                color="primary"
                                className="font-14 btn-block btn btn-primary"
                                onClick={handleReset}
                              >
                                Reset
                              </Button>
                            </Col>
                            <Col sm="3">
                              <div
                                className="text-sm-end"
                                style={{
                                  display: "flex",
                                  justifyContent: "end",
                                }}
                              >
                                <div style={{ width: 100 }} className="me-2">
                                  <Select
                                    placeholder={"Select Type"}
                                    name={"File Type"}
                                    value={fileType}
                                    onChange={e => {
                                      handleSelectType(e)
                                    }}
                                    options={fileTypeOptions}
                                    classNamePrefix="select2-selection me-2"
                                  />
                                </div>
                                <Button
                                  color="primary"
                                  className="font-16 btn-block btn btn-primary"
                                  onClick={setDownloadType}
                                >
                                  <i className="bx bx-upload me-1" />
                                  Export
                                </Button>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col sm="auto">
                              <div className="form-control form-floating mb-3">
                                <div className="position-relative text-end">
                                  SGD {parseFloat(totalBill).toFixed(2)}
                                </div>
                              </div>
                            </Col>
                            <Col sm="">
                              <div className="search-box ms-2 mb-2 d-inline-block">
                                <div className="position-relative">
                                  {/* <SearchBar {...toolkitProps.searchProps} />
                                  <i className="bx bx-search-alt search-icon" /> */}
                                  <input
                                    id="search-bar-0"
                                    type="text"
                                    className="form-control "
                                    placeholder="Search"
                                    value={searchKey}
                                    onChange={e => setSearchKey(e.target.value)}
                                  />

                                  <i className="bx bx-search-alt search-icon" />
                                </div>
                              </div>
                            </Col>
                          </Row>
                          <Row>
                            <Col xl="12">
                              <div className="table-responsive">
                                <BootstrapTable
                                  remote
                                  keyField={keyField}
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  defaultSorted={defaultSorted}
                                  classes={"table align-middle table-nowrap table-hover"}
                                  bordered={false}
                                  striped={false}
                                  responsive
                                  ref={node}
                                  noDataIndication={emptyDataMessage}
                                  onTableChange={handleTableChange}
                                />
                              </div>
                            </Col>
                          </Row>
                          <Row className="align-items-md-center mt-30">
                            <Col className="pagination pagination-rounded justify-content-end mb-2">
                              <PaginationListStandalone {...paginationProps} />
                            </Col>
                          </Row>
                        </React.Fragment>
                      )}
                    </ToolkitProvider>
                  )
                }}
              </PaginationProvider>
            </CardBody>
          </Card>
        </Col>
      </Row>
      {modal && (
        <>
          <InvoiceView
            modal={modal}
            toggle={toggle}
            bill={bill}
            gst={parseInt(settingData?.paymentSettings?.gst)}
          />
        </>
      )}
    </React.Fragment>
  )
}

export default withRouter(BillList)
